import { useContext } from "react";
import { AppContext } from "../App";
import { getCurrentYear } from "../Helpers";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { MdCall, MdEmail, MdLocationOn } from "react-icons/md";
import logo from "../assets/logo.png"

export default function Footer() {
  const appContext = useContext(AppContext);

  const links = [
    { name: "Home", item: "home" },
    { name: "About Us", item: "about_us" },
    { name: "Products & Solutions", item: "products" },
    { name: "Projects", item: "projects" },
    { name: "Contact", item: "contact_us" },
  ];
  const socialLinks = [
    { name: "Facebook", icon: <FaFacebookF size={14} />, href: "https://www.facebook.com" },
    { name: "Instagram", icon: <FaInstagram size={14} />, href: "https://www.instagram.com" },
    { name: "LinkedIn", icon: <FaLinkedinIn size={14} />, href: "https://www.linkedin.com" },
  ];

  return (
    <footer className="modern-footer">
      <div className="container">
        <div className="modern-footer-top">
          <div className="modern-footer-brand">
            <img src={logo} width={200} />
            <p className="modern-footer-subtitle">
              Built for teams that need dependable materials, timely transport, and responsive coordination.
            </p>

          </div>

          <div className="modern-footer-links">
            <h6 className="modern-footer-col-title">Quick Links</h6>
            {links.map((link, index) => (
              <button key={index} className="modern-footer-link" onClick={() => appContext.navTo({ item: link.item })}>
                {link.name}
              </button>
            ))}
          </div>

          <div className="modern-footer-contact">
            <h6 className="modern-footer-col-title">Reach Out</h6>
            <div className="modern-footer-info-row">
              <MdLocationOn size={16} className="flex-shrink-0 modern-footer-icon" />
              <span>PSSSF Commercial Complex, Sam Nujoma Rd, Sinza C, Dar es Salaam, Tanzania</span>
            </div>
            <div className="modern-footer-info-row">
              <MdEmail size={16} className="flex-shrink-0 modern-footer-icon" />
              <span>sales@groupv.co.tz</span>
            </div>
            <div className="modern-footer-info-row">
              <MdCall size={16} className="flex-shrink-0 modern-footer-icon" />
              <span>+255 654 253 235 </span>
            </div>
          </div>
        </div>

        <div className="modern-footer-bottom text-center d-flex flex-column mt-3">
          <p className="m-0">&copy; Group V Limited - {getCurrentYear()}. All rights reserved.</p>
          <hr className="m-0"/>
          <p className="m-0">
            Website Developed By{" "}
            <a target="_blank" rel="noreferrer" href="https://werenium.com">
              Werenium Technologies
            </a>
          </p>
        </div>
      </div>

      <style>{`
        .modern-footer {
          background: linear-gradient(145deg, #0d2438 0%, #081726 100%);
          color: #e8eef6;
          padding: 52px 0 20px;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          font-family: "FontRegular", "Segoe UI", sans-serif;
        }

        .modern-footer-top {
          display: grid;
          grid-template-columns: 1.45fr 1fr 1.2fr;
          gap: 18px;
          margin-bottom: 16px;
        }

        .modern-footer-brand,
        .modern-footer-links,
        .modern-footer-contact {
          background: rgba(255, 255, 255, 0.04);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 16px;
          padding: 20px;
        }

        .modern-footer-eyebrow {
          margin: 0 0 6px;
          font-size: 12px;
          letter-spacing: 0.12em;
          color: #96c8eb;
          font-family: "FontSemiBold", "Segoe UI", sans-serif;
          text-transform: uppercase;
        }

        .modern-footer-title {
          font-size: 22px;
          line-height: 1.35;
          margin: 0 0 8px;
          font-family: "FontSemiBold", "Segoe UI", sans-serif;
          color: #f3f7fc;
        }

        .modern-footer-subtitle {
          margin: 0;
          font-size: 16px !important;
          color: #b9c8d7;
        }

        .modern-footer-socials {
          margin-top: 16px;
          display: flex;
          gap: 10px;
        }

        .modern-footer-social {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: rgba(255, 255, 255, 0.08);
          border: 1px solid rgba(255, 255, 255, 0.16);
          color: #f1f6fb;
          transition: transform 0.2s ease, background-color 0.2s ease;
        }

        .modern-footer-social:hover {
          transform: translateY(-2px);
          background: rgba(150, 200, 235, 0.25);
          color: #ffffff;
        }

        .modern-footer-col-title {
          font-size: 16px;
          margin: 0 0 12px;
          font-family: "FontSemiBold", "Segoe UI", sans-serif;
          color: #f3f7fc;
        }

        .modern-footer-link {
          display: block;
          width: 100%;
          text-align: left;
          border: none;
          background: transparent;
          color: #d8e3ee;
          font-size: 14px;
          padding: 7px 0;
          line-height: 1.5;
          font-family: "FontRegular", "Segoe UI", sans-serif;
        }

        .modern-footer-link:hover {
          color: #9fd0ef;
        }

        .modern-footer-info-row {
          display: flex;
          align-items: flex-start;
          gap: 9px;
          font-size: 14px;
          line-height: 1.65;
          margin-bottom: 10px;
          color: #d8e3ee;
        }

        .modern-footer-info-row:last-child {
          margin-bottom: 0;
        }

        .modern-footer-icon {
          margin-top: 3px;
          color: #9dcbea;
        }

        .modern-footer-bottom {
          padding-top: 14px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          gap: 10px;
          font-size: 13px;
          line-height: 1.5;
          color: #b8c8d8;
        }

        .modern-footer-bottom a {
          color: #9fd0ef;
          text-decoration: none;
        }

        .modern-footer-bottom a:hover {
          text-decoration: underline;
        }

        @media (max-width: 991px) {
          .modern-footer-top {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 767px) {
          .modern-footer {
            padding: 42px 0 20px;
          }

          .modern-footer-brand,
          .modern-footer-links,
          .modern-footer-contact {
            border-radius: 14px;
            padding: 16px;
          }

          .modern-footer-title {
            font-size: 20px;
          }
        }
      `}</style>
    </footer>
  );
}
